import React, { useState } from 'react';
// import 'bootstrap/dist/css/bootstrap.min.css';
import { IoMdClose } from "react-icons/io";

const Resume = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <button
        type="button"
        className="btn btn-outline-primary btn-sm px-3"
        onClick={() => setShowModal(true)}
      >
        Resume
      </button>

      {showModal && (
        <div className="modal show fade d-block col-sm-7" tabIndex="-1" role="dialog">
          <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content shadow">
              <div className="modal-header d-flex justify-content-between">
                <h5 className="modal-title">Download My Resume</h5>
                <button
                  type="button"
                  className="close btn h1"
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                > 
                <IoMdClose/>
                </button>
              </div>
              <div className="modal-body text-center py-5">
                {/* <p>Select a version to download:</p> */}
                <div className="d-flex justify-content-center gap-3">
                  <a
                    href="/resumes/Krishna Bansal Frontend.pdf"
                  target='_blank'
                    className="btn btn-outline-success"
                  >
                    Frontend Resume
                  </a>
                  <a
                    href="/resumes/Krishna Bansal Backend.pdf"
                  target='_blank'
                    className="btn btn-outline-info"
                  >
                    Backend Resume
                  </a>
                </div>
              </div>
              {/* <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Close
                </button>
              </div> */}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Resume;
